<template>
  <ion-page id="mission">
    <WhiteHeader
      :back-button="!isOutsourcing"
      route-back="/planning"
      title="Détails d'une mission"
    />
    <ion-content class="ion-padding">
      <ion-refresher
        class="refresher-detail refresh-detail-delivery"
        slot="fixed"
        @ionRefresh="doRefresh($event)"
        @click="doRefresh($event)"
        ><ion-refresher-content></ion-refresher-content
      ></ion-refresher>

      <ion-segment
        v-if="mission && mission.can_create_qualimat_reports"
        :value="segment"
      >
        <ion-segment-button value="mission" @click="changeSegment('mission')">
          <ion-label>Mission</ion-label>
        </ion-segment-button>

        <ion-segment-button value="qualimat" @click="changeSegment('qualimat')">
          <ion-label>Qualimat</ion-label>
        </ion-segment-button>
      </ion-segment>

      <qualimat-report
        v-if="
          mission &&
          mission.can_create_qualimat_reports &&
          segment === 'qualimat'
        "
        ref="qualimatReportSegment"
        :dump-body-id="mission.dump_body_id"
      />

      <liste-rental-coupon
        v-if="hasCoupons && segment === 'mission'"
        ref="listeRentalCoupon"
        :rental-coupons="missionDetail.rental_coupons"
        type-mission="livraison"
      />

      <DayPart v-if="segment === 'mission'" :part="mission.day_part"></DayPart>
      <Date
        v-if="humanStart && segment === 'mission'"
        :start="humanStart"
        :end="humanEnd"
        :time-slot="missionItem.time_slot"
      />
      <hr v-if="segment === 'mission'" class="color-hr" />

      <Equipment
        v-if="segment === 'mission'"
        :machine_name="mission.machine_name"
        :machine_category="mission.machine_category"
        :machine_number="mission.machine_number"
        :machine_translation="mission.machine_translation"
        :machine_poids="mission.machine_poids"
        :tools="mission.tools"
        :voiture_pilote="missionItem.voiture_pilote"
        :attachments="mission.machine_attachments"
        :mission-id="missionItem.id"
        :transport-id="mission.id_transport"
        :dump-body="mission.dump_body"
        :dump-bodies="mission.dump_bodies"
        @refresh-mission="doRefresh"
        :display-dump-body-part="mission.display_dump_body_part"
        :disable-change-dump-body-message="disableChangeDumpBodyMessage"
      />
      <hr v-if="segment === 'mission'" class="color-hr" />
      <Delivery
        v-if="segment === 'mission'"
        :materials="missionItem.materials"
        :rounds="missionItem.rounds"
      />
      <hr v-if="segment === 'mission'" class="color-hr" />
      <ion-grid v-if="segment === 'mission'">
        <ion-row>
          <ion-col class="mt-15 column">
            <ion-note>Réf chantier :</ion-note>
            <ion-label v-if="missionItem.worksite_reference">
              {{ missionItem.worksite_reference }}
            </ion-label>
            <ion-label v-else class="text-red">Aucune</ion-label>
          </ion-col>
          <ion-col class="mt-15 column">
            <ion-note>N° commande :</ion-note>
            <ion-label v-if="missionItem.order_number">
              {{ missionItem.order_number }}
            </ion-label>
            <ion-label v-else class="text-red">Aucun</ion-label>
          </ion-col>
        </ion-row>
      </ion-grid>
      <hr v-if="segment === 'mission'" class="color-hr" />
      <ion-label v-if="segment === 'mission'" class="bold title-detail-mission"
        >Chargement<ion-badge
          v-if="
            missionItem.coupon_company &&
            missionItem.coupon_company === 'source' &&
            segment === 'mission'
          "
          color="success"
          class="ml-10"
          >Client</ion-badge
        ></ion-label
      >
      <information
        v-if="segment === 'mission'"
        :name-company="missionItem.source"
        :manager="missionDetail.source_contact"
        :manager_phone="missionDetail.source_contact_phone"
        :worksite_city="missionItem.source_location_city"
        :worksite_name="missionItem.source_location_name"
        :worksite_address="missionItem.source_location_address"
        :worksite_coordinates="missionItem.source_coordinates"
        :instructions="missionItem.source_instructions"
        :need_signature_source="missionItem.need_signature_source"
        ref="sourceMap"
      />
      <hr v-if="segment === 'mission'" class="color-hr" />
      <ion-label v-if="segment === 'mission'" class="bold title-detail-mission"
        >Déchargement<ion-badge
          v-if="
            missionItem.coupon_company &&
            missionItem.coupon_company === 'target'
          "
          color="success"
          class="ml-10"
          >Client</ion-badge
        ></ion-label
      >
      <information
        v-if="segment === 'mission'"
        :name-company="missionItem.target"
        :manager="missionDetail.target_contact"
        :manager_phone="missionDetail.target_contact_phone"
        :worksite_city="missionItem.target_location_city"
        :worksite_name="missionItem.target_location_name"
        :worksite_address="missionItem.target_location_address"
        :worksite_coordinates="missionItem.target_coordinates"
        :instructions="missionItem.target_instructions"
        :attachments="missionItem.attachments_with_categories"
        :mission-id="missionItem.id"
        ref="targetMap"
      />
      <hr v-if="segment === 'mission'" class="color-hr" />

      <new-rental-coupon
        v-if="missionItem.pricing_information && segment === 'mission'"
        type-mission="livraison"
        :has-coupons="hasCoupons"
        :has-questions="!isOutsourcing && mission.has_questions"
      />
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonPage,
  IonContent,
  IonLabel,
  IonRefresher,
  IonRefresherContent,
  IonBadge,
  toastController,
  IonRow,
  IonCol,
  IonGrid,
  IonNote,
  IonSegment,
  IonSegmentButton,
} from '@ionic/vue';
import {
  forceRefreshDetailMission,
  forceRefreshPlanning,
  getDetailMission,
  getMissionOrder,
  fetchMissionOutsourcing,
  fetchDetailMissionOutsourcing,
} from '@/services/driver/missionsOrders';
import Equipment from '@/components/driver/detailMission/Equipment';
import Information from '@/components/driver/detailMission/Information';
import Delivery from '@/components/driver/detailMission/Delivery';
import Date from '@/components/driver/detailMission/Date';
import DayPart from '@/components/driver/card/detailCardPlanning/DayPart.vue';
import ListeRentalCoupon from '@/components/driver/detailMission/ListeRentalCoupon';
import NewRentalCoupon from '@/components/driver/detailMission/NewRentalCoupon';
import QualimatReport from '@/components/driver/qualimatReport/QualimatReport.vue';
import WhiteHeader from '@/components/driver/header/WhiteHeader';
import HasMissionDetailMixin from '@/mixins/HasMissionDetailMixin';

export default {
  name: 'DeliveryDetail',
  components: {
    WhiteHeader,
    NewRentalCoupon,
    ListeRentalCoupon,
    QualimatReport,
    Date,
    DayPart,
    Delivery,
    Information,
    Equipment,
    IonPage,
    IonContent,
    IonLabel,
    IonRefresher,
    IonRefresherContent,
    IonBadge,
    IonRow,
    IonCol,
    IonGrid,
    IonNote,
    IonSegment,
    IonSegmentButton,
  },
  mixins: [HasMissionDetailMixin],
  data() {
    return {
      mission: {},
      missionItem: {},
      missionDetail: {},
      refreshInterval: null,
      segment: this.$route.query.segment || 'mission',
    };
  },

  ionViewWillEnter() {
    if (this.$route.query.segment) {
      this.segment = this.$route.query.segment;
    } else {
      this.segment = 'mission';
    }
  },

  // Launch auto-refresh when page gets displayed
  ionViewDidEnter() {
    this.doRefresh();

    if (!this.isOutsourcing) {
      this.refreshInterval = setInterval(() => {
        this.doRefresh();
      }, 60 * 1000);
    }

    setTimeout(() => {
      this.initMaps();
    }, 0);
  },

  ionViewWillLeave() {
    if (this.$refs.sourceMap) {
      this.$refs.sourceMap.removeMap();
    }
    if (this.$refs.targetMap) {
      this.$refs.targetMap.removeMap();
    }
  },

  // Stop auto-refresh when page quits
  ionViewDidLeave() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    }
  },

  mounted() {
    Promise.all([
      this.getMissionRequest(),
      this.getDetailMissionRequest(),
    ]).then(([mission, missionDetail]) => {
      this.afterFetches(mission, missionDetail);
    });
  },

  methods: {
    // keep track in url of current segment
    // this will allow to keep segment active when user refreshes page or go back
    changeSegment(segment) {
      this.segment = segment;
      this.$router.replace({
        query: { ...this.$route.query, segment },
      });
    },

    normalizeSegment(segment) {
      const allowedSegments = ['mission', 'qualimat'];

      if (!allowedSegments.includes(segment)) return 'mission';

      if (
        segment === 'qualimat' &&
        (!this.mission || !this.mission.can_create_qualimat_reports)
      ) {
        return 'mission';
      }

      return segment;
    },

    getMissionRequest() {
      if (this.isOutsourcing) {
        return fetchMissionOutsourcing(
          'livraison',
          this.$route.params.outsourcingToken,
        );
      }

      return getMissionOrder(
        this.$route.params.id,
        this.$route.params.idRide,
        'livraison',
      );
    },

    getDetailMissionRequest(forceRefresh = false) {
      if (this.isOutsourcing) {
        return fetchDetailMissionOutsourcing(
          'livraison',
          this.$route.params.outsourcingToken,
        );
      }

      if (forceRefresh) {
        return forceRefreshDetailMission(
          'livraison',
          this.$route.params.id,
          this.$route.params.idItem,
        );
      }

      return getDetailMission(
        'livraison',
        this.$route.params.id,
        this.$route.params.idItem,
      );
    },

    doRefresh(event) {
      const complete = () => {
        if (event && event.target && event.target.complete) {
          event.target.complete();
        }
      };

      if (this.segment === 'qualimat' && this.$refs.qualimatReportSegment) {
        return this.$refs.qualimatReportSegment
          .fetchPreviousDeliveries()
          .finally(complete);
      }

      if (!this.isOutsourcing) {
        try {
          forceRefreshPlanning();
        } catch (error) {
          console.log('[DeliveryDetail] Unable to force-refresh planning.');
        }

        if (!this.$route || !this.$route.params || !this.$route.params.id) {
          complete();
          return;
        }
      }

      Promise.all([
        this.getMissionRequest(),
        this.getDetailMissionRequest(true),
      ])
        .then(([mission, missionDetail]) => {
          this.afterFetches(mission, missionDetail);
        })
        .catch(() => {
          console.log('Unable to force-refresh delivery detail.');
        })
        .finally(complete);
    },

    async backPlanning() {
      const toast = await toastController.create({
        header: 'Changement',
        message: 'La mission ne vous est plus affectée',
        duration: 3000,
        color: 'success',
        position: 'top',
        cssClass: 'toast-rental-coupon',
      });
      await toast.present();

      this.$router.push('/planning');
    },

    afterFetches(mission, missionDetail) {
      if (!mission) {
        this.backPlanning();
        return;
      }

      this.mission = mission;
      this.missionDetail = missionDetail;

      for (const tiId in this.mission['transport_items']) {
        if (this.isOutsourcing) {
          // Handle both possible `outsourcingTokenKey` (id or outsourcing_token)
          const ti = this.mission['transport_items'][tiId];
          if (
            tiId === this.$route.params.outsourcingToken ||
            ti.outsourcing_token === this.$route.params.outsourcingToken
          ) {
            this.missionItem = this.mission['transport_items'][tiId];
          }
        } else {
          if (tiId === this.$route.params.idItem) {
            this.missionItem = this.mission['transport_items'][tiId];
          }
        }
      }

      // Init maps just in case
      this.$nextTick(() => {
        this.initMaps();
        this.segment = this.normalizeSegment(this.segment);
      });
    },

    /**
     * Using conditions to avoid this kind of error:
     * > TypeError: Cannot read properties of null (reading 'initMap')
     */
    initMaps() {
      if (this.$refs.sourceMap) {
        this.$refs.sourceMap.initMap();
      }
      if (this.$refs.targetMap) {
        this.$refs.targetMap.initMap();
      }
    },
  },
};
</script>

<style scoped lang="scss">
ion-segment {
  margin-bottom: 16px;

  ion-segment-button {
    text-transform: capitalize;

    &:not(.segment-button-checked) {
      border-bottom: 1px solid #e5e7eb !important;
    }

    ion-label {
      font-size: 18px;
      color: black !important;
    }
  }
}
</style>
